export const BULK_REMOVE_WAITLIST = 'lumahealth/WaitlistsPage/BULK_REMOVE_WAITLIST';
export const BULK_REMOVE_WAITLIST_SUCCESS = 'lumahealth/WaitlistsPage/BULK_REMOVE_WAITLIST_SUCCESS';
export const BULK_REMOVE_WAITLIST_ERROR = 'lumahealth/WaitlistsPage/BULK_REMOVE_WAITLIST_ERROR';

export const DIALOG_DELETE_HIDE = 'lumahealth/WaitlistsPage/DIALOG_DELETE_HIDE';
export const DIALOG_DELETE_SHOW = 'lumahealth/WaitlistsPage/DIALOG_DELETE_SHOW';

export const CHANGE_FILTER_PATIENT = 'lumahealth/WaitlistsPage/CHANGE_FILTER_PATIENT';
export const CHANGE_FILTER_PROVIDER = 'lumahealth/WaitlistsPage/CHANGE_FILTER_PROVIDER';

export const ITEMS_PER_PAGE = 15;

export const MOVE_WAITLIST = 'lumahealth/WaitlistsPage/MOVE_WAITLIST';
export const MOVE_WAITLIST_END = 'lumahealth/WaitlistsPage/MOVE_WAITLIST_END';
export const MOVE_WAITLIST_END_SUCCESS = 'lumahealth/WaitlistsPage/MOVE_WAITLIST_END_SUCCESS';
export const MOVE_WAITLIST_END_ERROR = 'lumahealth/WaitlistsPage/MOVE_WAITLIST_END_ERROR';
